module.exports = "<ul ng-show=legend class=pull-right><rm-chart-legend-item ng-repeat=\"item in legend\" item=item></rm-chart-legend-item></ul>";